



























































































import {
  DashboardVendedorNivel,
  NivelBonificacao,
} from "@/services/dashboard-vendedor.service";
import { Component, Prop, Vue } from "vue-property-decorator";
import ModalNiveisVendedor from "./ModalNiveisVendedor.vue";

@Component({
  components: {
    ModalNiveisVendedor,
  },
})
export default class WidgetNivelVendedor extends Vue {
  @Prop({ required: true }) readonly nivel!: DashboardVendedorNivel;
  @Prop({ required: true }) readonly niveis!: NivelBonificacao[];
  @Prop({ required: true }) readonly fechado!: boolean;
  @Prop({ default: "" }) readonly dataFechamento!: string;

  get dataFechamentoFormatada(): string {
    if (!this.dataFechamento) {
      return "";
    }

    const date = new Date(this.dataFechamento);
    if (Number.isNaN(date.getTime())) {
      return "";
    }

    return date.toLocaleDateString("pt-BR");
  }

  get pontosFaltantes(): number {
    return Math.max(0, this.nivel.pontosProximoNivel - this.nivel.pontosAtuais);
  }

  formatCurrency(value: number): string {
    return value.toLocaleString("pt-BR", {
      style: "currency",
      currency: "BRL",
      maximumFractionDigits: 2,
      minimumFractionDigits: 2,
    });
  }
}
